// Number formatter for Scoop format strings ($, %, decimals, K/M/B). Moved from KPI/utils.js.
export const getFormatter = (format, short) => {
    let options = {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true,
    }

    if (!format) return new Intl.NumberFormat('en-US', { ...options, maximumFractionDigits: 3 })

    if (format.includes('$')) {
        options.style = 'currency'
        options.currency = 'USD'
    }

    if (format.includes('%')) options.style = 'percent'

    const decimalPointIndex = format.indexOf('.')
    const commaIndex = format.indexOf(',')

    if (decimalPointIndex !== -1) {
        const decimalPart = format.slice(decimalPointIndex + 1)
        const numOptionalDigits = (decimalPart.match(/#/g) || []).length
        const numForcedDigits = (decimalPart.match(/0/g) || []).length

        options.minimumFractionDigits = numForcedDigits
        options.maximumFractionDigits = numForcedDigits + numOptionalDigits
    }

    if (commaIndex !== -1) options.useGrouping = true

    const shortFormats = ['K', 'M', 'B']

    if (shortFormats.some((s) => format.includes(s)) || short) options.notation = 'compact'

    return new Intl.NumberFormat('en-US', options)
}
